import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    paymentRunning: null,
    myTickets: [],
    userValidatedTicketsTemp: [],
    lastRead: null,
    initialized: false,
    initializing: false,
    // cartSize: parseInt(Math.random() * 15),
    cart: [],
    stopRadius: 750
  },
  mutations: {
    /* updateCartSize (state, { value }) {
      state.cartSize = value
    }, */
    addToCart(state, { el }) {
      /* let found = state.cart.find(e => e.productCode === el.productCode && e.origin === el.origin eccetera eccetera)
      if (found) {
        found.qta += el.qta
      } else {
        state.cart.push(el)
      } */
      state.cart.push(el)
    },
    /* changeQta(state, { id, qta }) {
      let el = state.cart.find(el => el.id === id)
      el.qta = qta
    }, */
    removeFromCart (state, { id }) {
      let idx = state.cart.findIndex(el => el.id === id)
      state.cart.splice(idx, 1)
    },
    resetCart (state) {
      state.cart.splice(0, state.cart.length)
    },
    setPaymentRunning (state, { value }) {
      state.paymentRunning = value
    },
    readFromLocalStorage (state) {
      if (!state.initializing && !state.initialized) {
        state.initializing = true
        try {
          let tgs = localStorage.getItem('myTickets')
          if (tgs) {
            state.myTickets = JSON.parse(tgs)
          }
          // state.myTickets = tickets
        } catch (e) {
          console.warn('myTickets', e)
        }
        try {
          let sr = localStorage.getItem('stopRadius')
          if (sr) {
            state.stopRadius = parseFloat(sr)
          }
        } catch (e) {
          console.warn('stopRadius', e)
        }
        try {
          // let v = localStorage.getItem('payment_running')
          let v = localStorage.getItem('payment_running')
          console.warn('payment_running read from localStorage', v)
          state.paymentRunning = v && JSON.parse(v)
        } catch (e) {
          console.warn('paymentRunning', e)
        }
        try {
          let v = localStorage.getItem('userValidatedTicketsTemp')
          // let v = localStorage.getItem('userValidatedTicketsTemp')
          state.userValidatedTicketsTemp = v && JSON.parse(v) || []
        } catch (e) {
          console.warn('userValidatedTicketsTemp', e)
        }

        state.initialized = true
        // console.log(state)
      }
    },
    updateStopRadius (state, { value }) {
      state.stopRadius = value
      localStorage.setItem('stopRadius', value)
    },
    saveNewTicket (state, { ticket }) {
      state.myTickets.push(ticket)
    },
    addPendingUserValidation (state, { id, value }) {
      let idx = state.userValidatedTicketsTemp.findIndex(t => t.id === id)
      if (idx > -1) {
        state.userValidatedTicketsTemp.splice(idx, 1, { id, value })
      } else {
        // console.warn('Pending user validation with id ' + id + ' non trovato!')
        state.userValidatedTicketsTemp.push({ id, value })
      }
    },
    removePendingUserValidation (state, { id }) {
      let idx = state.userValidatedTicketsTemp.findIndex(t => t.id === id)
      if (idx > -1) {
        state.userValidatedTicketsTemp.splice(idx, 1)
      } else {
        console.log('Pending user validation with id ' + id + ' non trovato!')
      }
    },
    replaceUserTickets (state, { tickets }) {
      state.myTickets = state.myTickets.filter(t => !t.userCode).concat(tickets)
      // state.myTickets.splice(0, state.myTickets.length, ...tickets)
    },
    setMyTicketUserValidated (state, { id, validated }) {
      let idx = state.myTickets.findIndex(t => t.id === id)
      if (idx > -1) {
        state.myTickets.splice(idx, 1, { ...state.myTickets[idx], userValidated: validated })
      } else {
        console.warn('Operazione su ticket non trovato!')
      }
    },
    setMyTicketVadValidated (state, { id, validated }) {
      let idx = state.myTickets.findIndex(t => t.id === id)
      if (idx > -1) {
        state.myTickets.splice(idx, 1, { ...state.myTickets[idx], vadValidated: validated })
      } else {
        console.warn('Operazione su ticket non trovato!')
      }
    },
    updateTicketData (state, { id, data }) {
      let idx = state.myTickets.findIndex(t => t.id === id)
      if (idx > -1) {
        let obj = { ...state.myTickets[idx], itemDescriptions: data.Description, details: {} }
        data.Details.forEach(dt => {
          obj.details[dt.key] = dt.value
        })
        state.myTickets.splice(idx, 1, obj)
      } else {
        console.warn('Operazione su ticket non trovato!')
      }
    },
    deleteTicket (state, { id }) {
      let idx = state.myTickets.findIndex(tag => tag.id === id)
      if (idx > -1) {
        state.myTickets.splice(idx, 1)
      }
    },
    fake (/*state*/) {}
  }
})
